type RuntimeConfigKey = 'AUTH0_AUDIENCE' | 'AUTH0_CLIENT_ID' | 'AUTH0_DOMAIN' | 'API_BASE_URL';

type RuntimeConfig = Partial<Record<RuntimeConfigKey, string>>;

export type AppConfig = {
  auth0Audience: string | undefined;
  auth0ClientId: string | undefined;
  auth0Domain: string | undefined;
  apiBaseUrl: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

const viteEnv = import.meta.env as Record<string, string | undefined>;

function getRuntimeConfig(): RuntimeConfig {
  return window.__APP_CONFIG__ ?? {};
}

function readOptionalConfig(runtimeKey: RuntimeConfigKey, viteKey: string) {
  const runtimeConfig = getRuntimeConfig();
  const runtimeValue = runtimeConfig?.[runtimeKey]?.trim();
  if (runtimeValue) {
    return runtimeValue;
  }

  const viteValue = viteEnv[viteKey]?.trim();
  if (viteValue) {
    return viteValue;
  }

  return undefined;
}

export function getAppConfig(): AppConfig {
  return {
    auth0Audience: readOptionalConfig('AUTH0_AUDIENCE', 'VITE_AUTH0_AUDIENCE'),
    auth0ClientId: readOptionalConfig('AUTH0_CLIENT_ID', 'VITE_AUTH0_CLIENT_ID'),
    auth0Domain: readOptionalConfig('AUTH0_DOMAIN', 'VITE_AUTH0_DOMAIN'),
    apiBaseUrl: readOptionalConfig('API_BASE_URL', 'VITE_API_BASE_URL') ?? '',
  };
}

export const appConfig = getAppConfig();